import React from "react";
import { Tag } from "./Tag";

/**
 * Labeled tag section for profile pages.
 * Renders nothing when items is empty.
 */
export default function ProfileTagSection({ heading, items = [], tone = "neutral" }) {
  const arr = Array.isArray(items) ? items : [];
  if (arr.length === 0) return null;
  return (
    <section className="mt-6">
      <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">{heading}</div>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {arr.map((v) => <Tag key={v} tone={tone}>{v}</Tag>)}
      </div>
    </section>
  );
}
